import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import DignifiedCareAtHome from "./sections/DignifiedCareAtHome";
import YourGuideThroughTheComplexity from "./sections/YourGuideThroughTheComplexity";
import ProductPresentation from "./sections/ProductPresentation";
import TheSalwaCareAdvantage from "./sections/TheSalwaCareAdvantage";
import ComprehensiveNavigationServices from "./sections/ComprehensiveNavigationServices";
import RealSuccessStories from "./sections/RealSuccessStories";
import ConnectWithSupport from "./sections/ConnectWithSupport";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <DignifiedCareAtHome />
      <YourGuideThroughTheComplexity />
      <ProductPresentation />
      <TheSalwaCareAdvantage />
      <ComprehensiveNavigationServices />
      <RealSuccessStories />
      <ConnectWithSupport />
      <Footer />
    </div>;
}